import { useRef } from 'preact/compat';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'preact/hooks';

export default function YesNoInput({
  label,
  name,
  currentValue,
  onChange,
  hidden,
  mode = 'toggle',
  disabled = false,
  labelTextClassName = '',
  children,
}) {
  /**
   *
   * @type {RefObject<HTMLInputElement|null>}
   */
  const rawInputRef = useRef(null);
  const [value, setValue] = useState(currentValue);

  const changeToggle = (e) => {
    const inputElement = e.target;
    const newState = inputElement.checked ? 'yes' : 'no';

    const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
      window.HTMLInputElement.prototype,
      'value'
    ).set;

    nativeInputValueSetter.call(rawInputRef.current, newState);

    const event = new Event('input', { bubbles: true });
    rawInputRef.current.dispatchEvent(event);

    setValue(newState);
  };

  useEffect(() => {
    setValue(currentValue);
  }, [currentValue]);

  const inputClassName =
    mode === 'toggle'
      ? 'toggle toggle-secondary'
      : 'checkbox checkbox-secondary';

  return (
    <div className={`${hidden ? 'form-control hidden' : 'form-control'}`}>
      <label className="label cursor-pointer w-fit">
        <input
          onChange={changeToggle}
          type="checkbox"
          className={inputClassName}
          disabled={disabled}
          checked={value === 'yes'}
        />
        <input
          onChange={onChange}
          ref={rawInputRef}
          type="text"
          className="hidden"
          name={name}
        />
        <div className="flex flex-col pl-5">
          <span className={`label-text ${labelTextClassName}`}>{label}</span>
          {children}
        </div>
      </label>
    </div>
  );
}

YesNoInput.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  currentValue: PropTypes.string,
  onChange: PropTypes.func,
  hidden: PropTypes.bool,
  mode: PropTypes.oneOf(['checkbox', 'toggle']),
  disabled: PropTypes.bool,
  labelTextClassName: PropTypes.string,
  children: PropTypes.node,
};
